import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./RightSidebar.css";
import GiftUsButton from "../components/GiftUsButton";
import TrendingSidebar from "../components/TrendingSidebar"; // ⭐ NEW

const RightSidebar = ({ currentUser, onOpenGiftModal }) => {
  const navigate = useNavigate();
  const isAdmin = currentUser?.group_id === 1;

  return (
    <aside className="right-sidebar">
      {/* Replace static trending with real trending */}
      <TrendingSidebar
        onPostSelect={(postId) => navigate(`/post/${postId}`)}
      />

      {isAdmin && (
        <>
          <h4>🔐 Admin Panel</h4>
          <button onClick={() => navigate("/admin-tools")}>
            🛠️ Admin Tools
          </button>
        </>
      )}

      <div className="gift-button-wrapper">
        <GiftUsButton onClick={onOpenGiftModal} />
      </div>
    </aside>
  );
};

export default RightSidebar;
